import React, {useState} from "react";
import CustomContainer from "../../components/CustomContainer";
import Loader from "../../components/Loader";
import {LinkIconButton} from "../../components/button/LinkIconButton";
import { useModels } from "../../helpers/models";
import columns from "./StoragePlaceTableConfig";
import FunctionalTableComponent from "../../components/table/FunctionalTableComponent";
import fields from "./StoragePlaceFormConfig";
import StoragePlaceInventory from "./StoragePlaceInventory";
import {hasStoragePlaceFullAccess} from "../../helpers/jwt";
import { useTranslation } from 'react-i18next';

const StoragePlaceTablePage = (props) => {
    const { t } = useTranslation();
    const models = useModels();

    const [loader, setLoader] = useState(false);

    function storagePlaceInventory(storagePlace, reload, setReload) {
        return <StoragePlaceInventory storagePlace={storagePlace}
                                      setLoader={setLoader}
                                      reload={reload}
                                      setReload={setReload}/>
    }

    return (
        <>
            <Loader loader={loader}/>
            <CustomContainer title={t("common.storage_places")}
                             
                             parent={
                                 <LinkIconButton
                                     model={models.storagePlace}
                                     props={props}
                                 />
                             }
            >


                <FunctionalTableComponent
                    title={t("common.storage_places_list")}
                    creationTitle={t("common.add_storage_place")}
                    creationFields={fields(t)}
                    api={models.storagePlace.url}
                    remove={true}
                    columns={columns}
                    header={true}
                    source={models.storagePlace.url}
                    setLoader={setLoader}
                    width={12}
                    editable={false}
                    pagination={true}
                    readOnly={!hasStoragePlaceFullAccess()}
                    additionalButtons={(storagePlace, reload, setReload) => storagePlaceInventory(storagePlace, reload, setReload)}
                    deleteModalTitle={t("forms.cabinet_deletion")}
                    deleteModalDescription={t("forms.confirm_cabinet_deletion")}
                />
            </CustomContainer>
        </>
    );
};

export default StoragePlaceTablePage;
